import React from "react";
import { Route, Routes } from "react-router-dom";
import RequireAuth from "../../../../common/routing/RequireAuth";
import ProjectSettingsContainer from "./ProjectSettingsContainer";
import ProjectTop from "./ProjectTop";
import AppliedProjectListContaner from "./AppliedProjectListContaner";

const ArchiveMypageProject: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<RequireAuth component={ProjectTop} />} />

      <Route
        path="settings"
        element={<RequireAuth component={ProjectSettingsContainer} />}
      />
      <Route
        path="applied"
        element={<RequireAuth component={AppliedProjectListContaner} />}
      />
    </Routes>
  );
};

export default ArchiveMypageProject;
